export default function(str) {
  let hash1 = 5381;
  let hash2 = hash1;

  for (let i = 0; i < str.length && str[i] != "\0"; i++) {
    hash1 = ((hash1 << 5) + hash1) ^ str.charCodeAt(i);
    // if (i == str.length - 1 || str[i + 1] == "\0") break;
    // hash2 = ((hash2 << 5) + hash2) ^ str.charCodeAt(i + 1);
  }

  return (hash1 * 1566083941).toString(16);
}
